import { render, staticRenderFns } from "./TitleDetail.vue?vue&type=template&id=7b4e61ce&scoped=true"
import script from "./TitleDetail.vue?vue&type=script&lang=ts"
export * from "./TitleDetail.vue?vue&type=script&lang=ts"
import style0 from "./TitleDetail.vue?vue&type=style&index=0&id=7b4e61ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4e61ce",
  null
  
)

export default component.exports